import clientHTTP from '../helpers/http-client';

const fetcher = async (url) => {
  const { data } = await clientHTTP.get(url);
  return data;
};

export default fetcher;
